// extracted by mini-css-extract-plugin
export var baseButton = "_vw-0";
export var controlsArrowKeys = "_vw-1";
export var controlsResetButton = "_vw-2";
export var lightGameButton = "_vw-4 _vw-0";
export var playAgainButton = "_vw-5 _vw-0";
export var startGameButton = "_vw-3 _vw-0";